export default __webpack_public_path__ + "static/media/user.27c26cdc.png";